/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PolicyCategoryEnum {
  MOBILITY = 'mobility',
  CURB_RULE = 'curb_rule',
}
